module.exports = require('./_shared')('native-function-to-string', Function.toString);



//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/core-js/modules/_function-to-string.js
// module id = 826
// module chunks = 0